import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
var MatureStrictBlockedOverlay = function (props) {
    var t = useTranslation().t;
    return (React.createElement(HiddenLayout, __assign({ icon: React.createElement(Hidden, null), title: t('deviationview.blocked.mature.strict'), text: t('deviationview.blocked.mature.strict.text'), strict: true }, props)));
};
MatureStrictBlockedOverlay.displayName = 'MatureStrictBlockedOverlay';
export default MatureStrictBlockedOverlay;
//# sourceMappingURL=MatureStrictBlocked.js.map